import { useEffect, useLayoutEffect, useState } from 'react';
import './App.scss';
import Sidnavbar from './Components/Sidnavbar/Sidnavbar';
import api from './Redux/Axios/middleware';
import { useNavigate } from 'react-router-dom';
import InvalidTokenDialog from './Components/InvalidToken/InvalidToken';
import { invalidToken } from './Redux/Slicers/InvalidToken/InvalidTokenSlice';
import { useAppDispatch, useAppSelector } from './Redux/Store/Hooks';
import Loading from './Components/Loading/Loading';
import 'primereact/resources/themes/saga-blue/theme.css'; // Theme (Choose one)
import 'primereact/resources/primereact.min.css'; // Core CSS
import 'primeicons/primeicons.css';
function App() {
  // const nav = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const nav = useNavigate();

  useLayoutEffect(() => {
    // request
    api.interceptors.request.use(
      (config) => {
        setLoading(true);
        return config;
      },
      (error) => {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    // response
    api.interceptors.response.use(
      (response) => {
        setLoading(false);
        return response;
      },
      (error) => {
        console.log('error', error);

        setLoading(false);
        // expired token
        if (error.response.data.error === "Unauthorized") {
          nav("/login");
          localStorage.clear();
          // dispatch(invalidToken(true));

          return;
        }

        return Promise.reject(error);
      }
    );
  }, []);

  return (
    <div className="App">
      <Sidnavbar />
      <InvalidTokenDialog />
      <Loading isLoading={loading} />
    </div>
  );
}

export default App;
